import { Time } from "@angular/common";
import { dateToArray, parseDate, parseTime, timeToArray } from "../components/Utils";

export class Timeslot {
  id: number = 0;
  date: Date = new Date;
  start: Time = { hours: 0, minutes: 0 };
  end: Time = { hours: 0, minutes: 0 };

  public static createFromJson(input: any): Timeslot {
    const data = new Timeslot();
    data.fromJson(input);
    return data
  }

  fromJson(input: any) {
    this.id = input['id'];
    this.date = parseDate(input['date']);
    this.start = parseTime(input['start']);
    this.end = parseTime(input['end']);
  }

  toJson(): any {
    return {
      id: this.id,
      date: dateToArray(this.date),
      start: timeToArray(this.start),
      end: timeToArray(this.end)
    };
  }
}
